
import { Component, Mixins } from "vue-property-decorator";
import { UserInfoEntity } from "@/types/responseEntity";
import { emptyUserInfo } from "@/types/factoryMethods";
import { getUserInfo } from "@/api";
import VForMixin from "@/mixins/VForMixin";

@Component
export default class SlideBar extends Mixins(VForMixin) {
  protected render() {
    return (
      <div class="author-info">
        <div class="author-summary">
          <div class="top-bar">作者</div>
          <div class="content">
            <router-link
              to={{
                name: "UserInfo",
                params: {
                  name: this.userInfo.loginname
                }
              }}
            >
              <img
                src={this.userInfo.avatar_url}
                alt={this.userInfo.loginname}
              />
            </router-link>
            <div class="detail">
              <router-link
                to={{
                  name: "UserInfo",
                  params: {
                    name: this.userInfo.loginname
                  }
                }}
              >
                <span>{this.userInfo.loginname}</span>
              </router-link>
              <p>积分 {this.userInfo.score}</p>
            </div>
          </div>
        </div>
        {this.userInfo.recent_topics.length > 0 ? (
          <div class="recent_topics">
            <div class="top-bar">作者最近主题</div>
            <ul>{this.mapListAndReturnElement(this.topicListLimit5)}</ul>
          </div>
        ) : (
          ""
        )}
        {this.userInfo.recent_replies.length > 0 ? (
          <div class="recent_replies">
            <div class="top-bar">作者最近回复</div>
            <ul>{this.mapListAndReturnElement(this.replyListLimit5)}</ul>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  private loginName = "";
  private userInfo: UserInfoEntity = emptyUserInfo();

  public async mounted() {
    this.loginName = this.$route.params.loginName;
    this.userInfo = await getUserInfo(this.loginName);
  }
  public get topicListLimit5() {
    return this.userInfo.recent_topics.slice(0, 5);
  }
  public get replyListLimit5() {
    return this.userInfo.recent_replies.slice(0, 5);
  }
}
